import { useCallback, useState } from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom-v5-compat";

import { useParams } from "hooks/useParam";
import { useUpdateProjectInvoice } from "queries/invoices";
import keys from "queries/keys";
import { reportError } from "services/errorReporter";

const useOnNext = ({ paymentType, afterAction, shouldSubmit = false, shouldNavigate = true }) => {
  const [isLoading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  const { requirementSlug, projectID, invoiceID } = useParams();
  const invoiceMutation = useUpdateProjectInvoice(projectID, invoiceID);
  const navigate = useNavigate();

  const onNext = useCallback(async () => {
    try {
      setLoading(true);
      await invoiceMutation.mutateAsync({ payment_type: paymentType, submit: shouldSubmit });
      let success = true;
      if (afterAction) success = await afterAction();

      queryClient.invalidateQueries(keys.projects(projectID));

      if (!success) return;

      if (shouldNavigate)
        navigate(`/projects/${projectID}/requirements/${requirementSlug}/summary`);
    } catch (e) {
      reportError(e, { paymentType, params: { invoiceID, projectID, requirementSlug } });
    } finally {
      setLoading(false);
    }
  }, [
    afterAction,
    invoiceID,
    invoiceMutation,
    navigate,
    paymentType,
    projectID,
    queryClient,
    requirementSlug,
    setLoading,
    shouldNavigate,
    shouldSubmit,
  ]);

  return { onNext, isLoading };
};

export default useOnNext;
